import {createApi} from '@common/apis/api.js';
import {MULTIMEDIA_REFERENCE_SERVICE_CODE} from '@/iamteacherpc/consts/multimedia.js';
import Axios from 'axios';

const api = createApi();

export default ({
    /**
     * 업로드 토큰을 얻는다.
     * 응답을 곧바로 startImageUpload 함수에 전달하면 된다.
     * @returns {Promise<AxiosResponse<T>>}
     */
    getUploadToken() {
        return api.get('multimedia/token', {
            params: {
                tokenType: 'UPLOAD',
                '_': new Date().getTime()
            }
        });
    },

    /**
     * 이미지 업로드를 시작한다.
     * @param tokenResponse - 토큰 API에서 받은 응답 그대로
     * @param file
     * @returns {Promise<AxiosResponse<T>>}
     */
    startImageUpload({tokenResponse, file}) {
        const url = `${tokenResponse.serverUrl}/upload/image/multipart?token=${tokenResponse.token}&serviceCode=SURVEY`
            + `&organizationNo=0&operationIds=&referenceServiceCode=${MULTIMEDIA_REFERENCE_SERVICE_CODE.ENROLMENT}`;

        const formData = new FormData();
        formData.append('file', file);

        return api.post(url, formData);
    },

    /**
     * 문서 업로드를 시작한다.
     * @param tokenResponse
     * @param file
     * @param progressCallback
     * @param requestCallback
     * @returns {Promise<AxiosResponse<T>>}
     */
    startDocumentUpload({tokenResponse, file, progressCallback, requestCallback}) {
        const url = `${tokenResponse.serverUrl}/upload/document/multipart?token=${tokenResponse.token}`
            + `&serviceCode=SURVEY&container=SURVEY_DOCUMENT`;

        const formData = new FormData();
        formData.append('file', file);

        return api.post(url, formData, {
            onUploadProgress: progressCallback,
            cancelToken: new Axios.CancelToken(function executor(cancel) {
                requestCallback({cancel});
            }),
        });
    },

    /**
     * 설문 작성화면에서 첨부한 문서 다운로드를 위한 임시 매핑
     * @param objectStorageNo
     * @param key
     * @returns {Promise<AxiosResponse<any>>}
     */
    mappingTempDocument({objectStorageNo, key}) {
        return api.post('/external/documents/temporary', {
            objectStorageNo,
            key,
        });
    },
});
